import { EMR_APIS } from "@/api_framework/api_config";
import axios from "axios";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";

export interface IEMRClinicConfig {
  vitals_enabled: boolean;
  show_basic_checkup: boolean;
  mucous_membrane_options: string[];
  hydration_options: string[];
  pain_options: string[];
}

export const useEMRClinicConfigAPI = () => {
  const configuration = useConfiguration();
  const [config, setConfig] = useState<IEMRClinicConfig | null>(null);

  const execute = useCallback(
    async (clinicId: string) => {
      if (!clinicId) return null;
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res = await axios.get(`${EMR_APIS?.EMR_CLINIC_CONFIG?.baseURL}`, {
          params: { clinic_id: clinicId },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (res.data?.status) {
          setConfig(res.data.data);
          return res.data.data as IEMRClinicConfig;
        }
      } catch {
        // silently fail - vitals just won't show
      }
      return null;
    },
    [configuration],
  );

  return { config, execute };
};
